import { useMemo, useState } from 'react'
import EstoqueHttp from '../../../../services/api/https/estoque/Estoque.http'
import { errorHandler } from '../../../../services/util/error.service'
import { menuItemsAllowed } from '../../../../services/permission/menus'

export const OPERACOES_TYPE = {
  ENTRADA: 'Entrada',
  SAIDA: 'Saída',
  TRANSFERENCIA: 'Transferência',
}

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_OPERACOES: 'Carregando as Operações de Estoques',
  DELETE: 'Apagando operação',
}

const INITIAL_STATE = {
  operacoes_entrada_saida: [],
  operacoes_transferencia: [],
  operacoes_datatable: [],
  showModal: false,
  selectedOperacao: null,
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  modalConfirmDelete: {
    show: false,
    data: null,
  },
}

export default function useCadastroOperacaoEstoque() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers
    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      async getOperacoesEstoque(tpId) {
        EstoqueHttp.getOperacoesEstoque(tpId)
          .then(({ operacoes_entrada_saida, operacoes_transferencia }) =>
            setState(prevState => ({
              ...prevState,
              operacoes_entrada_saida,
              operacoes_transferencia,
              operacoes_datatable: [
                ...operacoes_entrada_saida,
                ...operacoes_transferencia.map(o => ({ ...o, type: OPERACOES_TYPE.TRANSFERENCIA })),
              ],
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      async deleteOperacaoEstoque(tpId, selectedOperacao) {
        if (selectedOperacao.type !== OPERACOES_TYPE.TRANSFERENCIA) {
          await EstoqueHttp.deleteOperacaoEstoque(tpId, selectedOperacao.id)
            .then(res =>
              setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.GET_OPERACOES })),
            )
            .catch(err =>
              setState(prevState => ({
                ...prevState,
                loadingMessage: LOAD_MESSAGE.NONE,
                errorMessage: errorHandler(err),
              })),
            )
        } else {
          await EstoqueHttp.deleteOperacaoEstoqueTransferencia(tpId, selectedOperacao.id)
            .then(res =>
              setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.GET_OPERACOES })),
            )
            .catch(err =>
              setState(prevState => ({
                ...prevState,
                loadingMessage: LOAD_MESSAGE.NONE,
                errorMessage: errorHandler(err),
              })),
            )
        }
      },

      //Events
      onInit(selectedTp) {
        if (selectedTp)
          setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.GET_OPERACOES }))
        else
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione um Operador Logístico' }))
      },

      toggleModal(visible, selectedOperacao) {
        setState(prevState => ({ ...prevState, showModal: visible, selectedOperacao }))
      },

      onModalSave(type, operacaoEstoque) {
        setState(prevState => {
          const index = prevState.operacoes_datatable.findIndex(
            e => e.id === operacaoEstoque.id && e.type === type,
          )
          if (index !== -1) {
            prevState.operacoes_datatable[index] = operacaoEstoque
          } else {
            prevState.operacoes_datatable = [...prevState.operacoes_datatable, operacaoEstoque]
            if (type === OPERACOES_TYPE.SAIDA || type === OPERACOES_TYPE.ENTRADA) {
              prevState.operacoes_entrada_saida = [
                ...prevState.operacoes_entrada_saida,
                operacaoEstoque,
              ]
            }
          }
          return {
            ...prevState,
            showModal: false,
            selectedOperacao: null,
            loadingMessage: LOAD_MESSAGE.GET_OPERACOES,
          }
        })
      },

      onMenuItemClicked(item, operacao) {
        switch (item) {
          case '1. Apagar':
            setState(prevState => ({
              ...prevState,
              modalConfirmDelete: { show: true, data: { ...operacao } },
            }))
            break
          case '2. Ver Transferência':
            this.toggleModal(true, operacao)
            break
          case '3. Editar':
            setState(prevState => ({
              ...prevState,
              selectedOperacao: operacao,
              showModal: true,
            }))
            break
          default:
            break
        }
      },

      onMenuItemApagarClicked(operacao) {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.DELETE,
          selectedOperacao: operacao,
          modalConfirmDelete: { show: false, data: null },
        }))
      },

      onModalDeleteClose() {
        setState(prevState => ({
          ...prevState,
          modalConfirmDelete: { show: false, data: null },
        }))
      },

      onModalDeleteSave(operacao) {
        this.onMenuItemApagarClicked(operacao)
      },

      verifyMenuItemAllowed(menuItem) {
        return menuItemsAllowed([menuItem]).length > 0
      },
    }
  }, [])

  return { state, localDispatch }
}
